<template>
    <div data-grid-width="1" data-grid-height="1" class="ajax-subscribe-form">
        <div class="subscribe-tile pt-4 pb-5">

            <div class="contact-form-success" v-if="formSuccess">
                <h3 class="heading-3 text-center contact-form-success-header mt-3 mb-0"><slot name="hl-subscribe-successtitle"></slot></h3>
                <div class="text-center contact-form-success-message">{{responseMessage}}</div>
            </div>

            <div class="contact-form-main" v-if="!formSuccess">
                <div class="text-center subscribe-tile-sign-in ">
                    <p class="heading-2"><slot name="hl-subscribe-signuptitledefault"></slot></p>
                </div>
                <form action="/" class="subscribe-tile-form" id="subscrie-tile-form">
                    <InputWithPlaceholderLabel inputType="email" inputId="email-address" :labelText="getText('hl-subscribe-emailplaceholder')" :class=" { 'mb-4': !formError,  'error': formError }" :centerLabel="true" @input="fieldChanged" />
                    <p class="subscribe-tile-error error mb-4" v-if="formError"><slot name="hl-subscribe-invalidemailerror"></slot></p>
                    <input type="submit" class="hl-button" :value="getText('hl-subscribe-subscribebuttontext')" @click.prevent="submitForm" />
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import InputWithPlaceholderLabel from "../components/InputWithPlaceholderLabel.vue";
    import HButton from "../components/HButton.vue";

    export default {
        components: {
            InputWithPlaceholderLabel,
            HButton
        },
		props:
        {
            cultureCode: String
        },
        data() {
            return {
                emailAddress: "",
                formError: false,
                formSuccess: false,
                errorMessage: "",
                responseMessage: ""
            }
        },
        methods: {
            getText(key) {
                return this.$slots[key][0].text.trim();
            },
            fieldChanged(value) {
                this.emailAddress = value;
            },
            submitForm() {

                this.$axios(
                    {
                        url: this.cultureCode.toLowerCase() + "/signup",
                        data: { email: this.emailAddress },
                        headers: { 'Content-Type': 'application/json' },
                        method: "post"
                    })
                    .then((response) => {
                        console.log(response);
                        if (response.data.IsSuccessStatusCode === false || !response.data.message) {
                            this.formError = true;
                            this.formSuccess = false;
                        } else {
                            this.responseMessage = response.data.message;
                            this.formSuccess = true;
                            this.formError = false;
                        }
                    }).catch((error) => {
                        this.formError = true;
                        this.formSuccess = false;
                    });
            }
        }

    }
</script>

<style lang="scss">
    .subscribe-tile {
        border-top: 1px solid #d8d8d8;
        border-bottom: 1px solid #d8d8d8;
        margin-top: $bigPaddingSize/4 !important;
        margin-bottom: $bigPaddingSize/3 !important;

        .error {
            color: $red;
        }

        .heading-2 {
            font-size: rem(28);
            margin-bottom: rem(0);

            @include respond-below(sm) {
                font-size: rem(24);
            }
        }

        .input-with-placeholder-label {
            width: calc(100% - 30px);
        }

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        max-width: 100%;

        .subscribe-tile-form {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .hl-button {
                width: 200px;
            }
        }
    }

    .article-tile-grid {
        .subscribe-tile {
        }
    }
</style>
